/* == Nora Janne 3.0: bedragen opmaken zoals de winkel (Impulse levert Shopify.formatMoney niet mee). */
(function () {
  window.Shopify = window.Shopify || {};
  if (typeof Shopify.formatMoney === 'function') return;
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var f = format || window.money_format || '€{{amount_with_comma_separator}}';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(n, dec, thou, decs) {
      var num = (Number(n) / 100).toFixed(dec);
      var parts = num.split('.');
      var ints = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
      return ints + (parts[1] ? decs + parts[1] : '');
    }
    var val;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': val = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = fmt(cents, 2, "'", '.'); break;
      default: val = fmt(cents, 2, ',', '.');
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, val);
  };
})();

/* Scripts uit onze productpagina die de trechter laten werken.
   Alleen de mechanieken, geen thema-opmaak. Jouw Claude bouwt de liquid-blokken en CSS
   zelf in jouw thema (zie 05-PDP-FUNNEL-EN-KACHING-PROMPT.md) en laadt dit bestand in
   layout/theme.liquid. Selectors (.mrv-bundel*, .mrv-story*, [data-mrv-video],
   [data-mrv-subline]) moeten overeenkomen met de blokken die je maakt. */

/* == 7. Bundelkiezer boven de bestelknop ===================================
   Hoort bij blocks/_bundle-deals.liquid. De korting komt van Shopify's
   automatische kortingen; dit stuurt alleen de juiste stuks mee via Ella's
   eigen bestelknop (items[n][id] in het formulier, id-veld even uit). */
(function () {
  'use strict';
  var GEEN_KLEUR = ['kleur', 'colo', 'farbe', 'couleur', 'colore'];
  var GEEN_MAAT = ['size', 'maat', 'größe', 'grosse', 'taille', 'taglia', 'talla'];

  function geld(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || window.money_format || '{{amount}}');
    }
    return (cents / 100).toFixed(2);
  }
  function optieIndex(opties, woorden, fallback) {
    for (var i = 0; i < opties.length; i++) {
      var n = String(opties[i] || '').toLowerCase();
      for (var j = 0; j < woorden.length; j++) if (n.indexOf(woorden[j]) >= 0) return i;
    }
    return fallback;
  }

  function init(blok) {
    if (blok.hasAttribute('data-mrv-deals-klaar')) return;
    var bron = blok.querySelector('[data-mrv-deals-data]');
    if (!bron) return;
    var data;
    try { data = JSON.parse(bron.textContent); } catch (e) { return; }
    blok.setAttribute('data-mrv-deals-klaar', '1');

    var format = blok.getAttribute('data-money-format') || window.money_format;
    var info = blok.closest('product-info') || document;
    var form = info.querySelector('form[action*="/cart/add"]') || document.querySelector('product-info form[action*="/cart/add"]');
    if (!form) return;
    var idVeld = form.querySelector('[name="id"]'); /* Nora Janne 3.0: Impulse gebruikt <select name="id"> */
    var knop = form.querySelector('button[name="add"], .product-form__submit');
    var knopTekst = knop && knop.querySelector('span');
    var knopOrigineel = knopTekst ? knopTekst.textContent : '';
    var kaarten = Array.prototype.slice.call(blok.querySelectorAll('[data-deal]'));
    var foutVeld = blok.querySelector('[data-fout]');
    var kleurIdx = data.kleurIndex, maatIdx = data.maatIndex;
    var partner = data.partner;
    if (partner) {
      partner.kleurIdx = optieIndex(partner.opties || [], GEEN_KLEUR, 0);
      partner.maatIdx = optieIndex(partner.opties || [], GEEN_MAAT, partner.opties && partner.opties.length > 1 ? 1 : -1);
    }

    function huidige() {
      var id = idVeld && idVeld.value;
      for (var i = 0; i < data.varianten.length; i++) if (String(data.varianten[i].id) === String(id)) return data.varianten[i];
      return data.varianten[0];
    }
    function variantVan(lijst, id) {
      for (var i = 0; i < lijst.length; i++) if (String(lijst[i].id) === String(id)) return lijst[i];
      return null;
    }
    function kleurenVan(lijst, idx) {
      var uit = [], gezien = {};
      for (var i = 0; i < lijst.length; i++) {
        var k = lijst[i].o[idx];
        if (gezien[k]) { if (!uit[gezien[k] - 1].img && lijst[i].img) uit[gezien[k] - 1].img = lijst[i].img; continue; }
        uit.push({ n: k, img: lijst[i].img || null });
        gezien[k] = uit.length;
      }
      return uit;
    }
    function fotoVanKleur(lijst, idx, kleur) {
      for (var i = 0; i < lijst.length; i++) if (lijst[i].o[idx] === kleur && lijst[i].img) return lijst[i].img;
      return null;
    }

    /* verschuiving: stuk 2 begint op de volgende kleur, stuk 3 op de kleur
       daarna (rondlopend), met dezelfde maat als boven op de pagina. */
    function maakKiezer(item, lijst, kIdx, mIdx, start, verschuiving) {
      var kleurSel = item.querySelector('[data-kleur]');
      var maatSel = item.querySelector('[data-maat]');
      var thumb = item.querySelector('[data-thumb]');
      var kleuren = kleurenVan(lijst, kIdx);
      var geraakt = false;
      kleurSel.innerHTML = '';
      kleuren.forEach(function (k) {
        var o = document.createElement('option'); o.value = k.n; o.textContent = k.n; kleurSel.appendChild(o);
      });
      if (mIdx < 0 || (lijst.length === 1 && /default title/i.test(lijst[0].o.join(' ')))) maatSel.hidden = true;

      function vulMaten(wensMaat) {
        var kleur = kleurSel.value;
        maatSel.innerHTML = '';
        var eerste = null;
        lijst.forEach(function (v) {
          if (v.o[kIdx] !== kleur) return;
          var o = document.createElement('option');
          o.value = String(v.id);
          o.textContent = mIdx >= 0 ? v.o[mIdx] + (v.a ? '' : ' - ' + data.teksten.uitverkocht) : v.o.join(' / ');
          o.disabled = !v.a;
          maatSel.appendChild(o);
          if (!eerste && v.a) eerste = o;
          if (wensMaat && mIdx >= 0 && v.o[mIdx] === wensMaat && v.a) maatSel.value = o.value;
        });
        if (!maatSel.value || maatSel.selectedOptions[0].disabled) { if (eerste) maatSel.value = eerste.value; }
        var foto = fotoVanKleur(lijst, kIdx, kleur);
        if (foto) { thumb.src = foto; thumb.hidden = false; } else { thumb.removeAttribute('src'); thumb.hidden = true; }
      }
      function zet(variant) {
        if (!variant) return;
        var kleur = variant.o[kIdx];
        if (verschuiving && kleuren.length > 1) {
          var i = 0;
          for (var q = 0; q < kleuren.length; q++) if (kleuren[q].n === kleur) { i = q; break; }
          kleur = kleuren[(i + verschuiving) % kleuren.length].n;
        }
        kleurSel.value = kleur;
        vulMaten(mIdx >= 0 ? variant.o[mIdx] : null);
        if (!verschuiving && variantVan(lijst, variant.id) && variant.a) maatSel.value = String(variant.id);
      }
      kleurSel.addEventListener('change', function () {
        geraakt = true;
        var nu = maatSel.selectedOptions[0];
        vulMaten(nu && mIdx >= 0 ? variantVan(lijst, nu.value).o[mIdx] : null);
        teken();
      });
      maatSel.addEventListener('change', function () { geraakt = true; teken(); });
      zet(start);
      return {
        variant: function () { return variantVan(lijst, maatSel.value); },
        volg: function (variant) { if (!geraakt) zet(variant); }
      };
    }

    var kiezers = {};
    kaarten.forEach(function (kaart) {
      var soort = kaart.getAttribute('data-deal');
      var items = kaart.querySelectorAll('[data-item]');
      kiezers[kaart.dataset.qty + soort] = [];
      items.forEach(function (item, idx) {
        if (item.getAttribute('data-item') === 'partner') {
          if (!partner) return;
          var pv = null;
          for (var i = 0; i < partner.varianten.length; i++) if (partner.varianten[i].a) { pv = partner.varianten[i]; break; }
          kiezers[kaart.dataset.qty + soort].push({ partner: true, k: maakKiezer(item, partner.varianten, partner.kleurIdx, partner.maatIdx, pv || partner.varianten[0], 0) });
        } else {
          kiezers[kaart.dataset.qty + soort].push({ partner: false, k: maakKiezer(item, data.varianten, kleurIdx, maatIdx, huidige(), idx) });
        }
      });
    });

    function gekozenKaart() {
      for (var i = 0; i < kaarten.length; i++) if (kaarten[i].classList.contains('is-gekozen')) return kaarten[i];
      return null;
    }
    function stuks(kaart) {
      var soort = kaart.getAttribute('data-deal');
      var lijst = [];
      if (soort === 'single') { lijst.push(huidige()); return lijst; }
      var ks = kiezers[kaart.dataset.qty + soort] || [];
      if (soort === 'pair') {
        lijst.push(huidige());
        ks.forEach(function (x) { lijst.push(x.k.variant()); });
        return lijst;
      }
      ks.forEach(function (x) { lijst.push(x.k.variant()); });
      return lijst;
    }
    function fout(tekst) {
      if (!foutVeld) return;
      foutVeld.textContent = tekst || '';
      foutVeld.hidden = !tekst;
    }

    function teken() {
      var v = huidige();
      var prijs = v.p, vol = Math.max(v.c || v.p, v.p);
      kaarten.forEach(function (kaart) {
        var soort = kaart.getAttribute('data-deal');
        var qty = parseInt(kaart.getAttribute('data-qty'), 10) || 1;
        var pct = parseInt(kaart.getAttribute('data-pct'), 10) || 0;
        var zetTekst = function (sel, cents) { var el = kaart.querySelector(sel); if (el) el.textContent = geld(cents, format); };
        if (soort === 'single') {
          zetTekst('[data-prijs]', prijs); zetTekst('[data-vol]', vol);
        } else if (soort === 'pack') {
          var ks = kiezers[qty + soort] || [];
          var som = 0, somVol = 0, n = 0;
          // 2026-09-15: besparing = som van de losse prijzen min de pakketprijs (niet de compare-at)
          ks.forEach(function (x) { var w = x.k.variant(); if (w) { som += w.p; somVol += w.p; n++; } });
          if (n < qty) { som = prijs * qty; somVol = prijs * qty; }
          var bundel = Math.round(som * (100 - pct) / 100);
          zetTekst('[data-prijs]', bundel); zetTekst('[data-vol]', somVol);
          zetTekst('[data-stuk]', Math.round(bundel / qty)); zetTekst('[data-spaar]', somVol - bundel);
        } else if (soort === 'pair' && partner) {
          var pk = (kiezers[qty + soort] || [])[0];
          var pv = pk && pk.k.variant();
          var hoofd = Math.round(prijs * (100 - pct) / 100);
          var pp = pv ? Math.round(pv.p * (100 - pct) / 100) : 0;
          var pvol = pv ? Math.max(pv.c || pv.p, pv.p) : 0;
          zetTekst('[data-prijs]', hoofd + pp); zetTekst('[data-vol]', vol + pvol);
          zetTekst('[data-spaar]', vol + pvol - hoofd - pp);
          zetTekst('[data-paar-hoofd]', hoofd); zetTekst('[data-paar-hoofd-vol]', vol);
          zetTekst('[data-paar-partner]', pp); zetTekst('[data-paar-partner-vol]', pvol);
          var pf = kaart.querySelector('[data-partner-foto]');
          if (pf && pv && pv.img) pf.src = pv.img;
        }
      });
      knopBijwerken();
    }
    function knopBijwerken() {
      var kaart = gekozenKaart();
      var qty = kaart ? parseInt(kaart.getAttribute('data-qty'), 10) || 1 : 1;
      var tekst = qty > 1 ? data.teksten.toevoegenAantal.replace('[n]', qty) : (knopOrigineel || data.teksten.toevoegen);
      // 2026-09-15 (operator): prijs van de gekozen kaart achter de knoptekst, met een stip ertussen.
      var prijsEl = kaart ? kaart.querySelector('[data-prijs]') : null;
      var prijs = prijsEl ? prijsEl.textContent.trim() : '';
      var vul = function (el) {
        if (!el) return;
        el.textContent = '';
        el.appendChild(document.createTextNode(tekst));
        if (prijs) {
          var stip = document.createElement('span'); stip.className = 'mrv-knop__stip'; stip.setAttribute('aria-hidden', 'true');
          var p = document.createElement('span'); p.className = 'mrv-knop__prijs'; p.textContent = prijs;
          el.appendChild(stip); el.appendChild(p);
        }
      };
      vul(knopTekst);
      var sticky = document.querySelector('.sticky-atc button[name="add"] span, sticky-atc button[name="add"] span');
      if (sticky && !blok.closest('quick-view-modal, quick-add-modal')) vul(sticky);
    }
    function kies(kaart) {
      kaarten.forEach(function (k) {
        var aan = k === kaart;
        k.classList.toggle('is-gekozen', aan);
        var r = k.querySelector('.mrv-deals__radio'); if (r) r.checked = aan;
        var items = k.querySelector('[data-items]'); if (items) items.hidden = !aan;
      });
      fout('');
      teken();
    }
    kaarten.forEach(function (kaart) {
      kaart.addEventListener('click', function (e) {
        if (e.target.closest('select, a')) return;
        if (!kaart.classList.contains('is-gekozen')) { e.preventDefault(); kies(kaart); }
      });
      var r = kaart.querySelector('.mrv-deals__radio');
      if (r) r.addEventListener('change', function () { if (r.checked) kies(kaart); });
    });

    var voorkeur = blok.getAttribute('data-preselect') || '2';
    var start = null;
    kaarten.forEach(function (k) {
      if (!start && ((voorkeur === '1' && k.dataset.deal === 'single') || (k.dataset.deal === 'pack' && k.dataset.qty === voorkeur))) start = k;
    });
    kies(start || kaarten[0]);

    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') {
        var v = huidige();
        Object.keys(kiezers).forEach(function (sl) {
          kiezers[sl].forEach(function (x) { if (!x.partner) x.k.volg(v); });
        });
        teken();
      }
    });
    info.addEventListener && info.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) window.setTimeout(teken, 400);
    });

    form.addEventListener('submit', function (e) {
      var kaart = gekozenKaart();
      if (!kaart || kaart.dataset.deal === 'single') return;
      var lijst = stuks(kaart);
      for (var i = 0; i < lijst.length; i++) {
        if (!lijst[i] || !lijst[i].a) {
          e.preventDefault(); e.stopImmediatePropagation();
          fout(data.teksten.kiesAlles);
          return;
        }
      }
      fout('');
      var tel = {};
      lijst.forEach(function (v) { tel[v.id] = (tel[v.id] || 0) + 1; });
      var velden = [];
      var n = 0;
      Object.keys(tel).forEach(function (id) {
        var a = document.createElement('input'); a.type = 'hidden'; a.name = 'items[' + n + '][id]'; a.value = id;
        var b = document.createElement('input'); b.type = 'hidden'; b.name = 'items[' + n + '][quantity]'; b.value = String(tel[id]);
        form.appendChild(a); form.appendChild(b); velden.push(a, b); n++;
      });
      var qtyVeld = form.querySelector('input[name="quantity"]');
      if (idVeld) idVeld.disabled = true;
      if (qtyVeld) qtyVeld.disabled = true;
      window.setTimeout(function () {
        velden.forEach(function (x) { x.remove(); });
        if (idVeld) idVeld.disabled = false;
        if (qtyVeld) qtyVeld.disabled = false;
      }, 0);
    }, true);

    if (!blok.closest('quick-view-modal, quick-add-modal')) {
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.sticky-atc button[name="add"], sticky-atc button[name="add"]');
        if (!b) return;
        var kaart = gekozenKaart();
        if (!kaart || kaart.dataset.deal === 'single') return;
        e.preventDefault(); e.stopImmediatePropagation();
        if (knop) knop.click(); else if (form.requestSubmit) form.requestSubmit();
      }, true);
    }
  }

  function alles() { document.querySelectorAll('[data-mrv-deals]:not([data-mrv-deals-klaar])').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles); else alles();
  /* Nora Janne 3.0: Impulse zet de productinfo soms later in de pagina; daarom ook na 'load' en even later nog eens. */
  window.addEventListener('load', alles);
  setTimeout(alles, 1200);
  /* Alleen reageren als er echt een kiezer bijkomt (snelkijk), gebundeld. */
  if (window.MutationObserver) {
    var wacht;
    new MutationObserver(function (lijst) {
      for (var i = 0; i < lijst.length; i++) {
        var nw = lijst[i].addedNodes;
        for (var j = 0; j < nw.length; j++) {
          var n = nw[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-mrv-deals') || n.querySelector('[data-mrv-deals]'))) {
            clearTimeout(wacht); wacht = setTimeout(alles, 100); return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();


/* == Verhaalvideo's pas laden en afspelen als ze in beeld komen (2026-09-13)
   Zonder autoplay-attribuut downloadt de browser niets (preload none). Zodra
   een video binnen 300 px van het scherm komt zetten we preload aan en
   spelen we af; uit beeld pauzeren we, dat scheelt batterij en data. */
(function () {
  var videos = document.querySelectorAll('video[data-mrv-video]');
  if (!videos.length) return;
  function speel(v) {
    if (v.getAttribute('preload') === 'none') v.setAttribute('preload', 'auto');
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  if (!('IntersectionObserver' in window)) {
    videos.forEach(speel);
    return;
  }
  var io = new IntersectionObserver(function (items) {
    items.forEach(function (it) {
      if (it.isIntersecting) speel(it.target);
      else if (!it.target.paused) it.target.pause();
    });
  }, { rootMargin: '300px 0px' });
  videos.forEach(function (v) { io.observe(v); });
  // Vangnet: bij scrollen zelf meten of een video binnen 300 px van het
  // scherm staat (browsers zonder/met slapende IntersectionObserver).
  var wacht = false;
  function bijScroll() {
    if (wacht) return;
    wacht = true;
    setTimeout(function () {
      wacht = false;
      var h = window.innerHeight || document.documentElement.clientHeight;
      videos.forEach(function (v) {
        var r = v.getBoundingClientRect();
        if (r.bottom > -300 && r.top < h + 300) { if (v.paused) speel(v); }
        else if (!v.paused) v.pause();
      });
    }, 200);
  }
  window.addEventListener('scroll', bijScroll, { passive: true });
})();


/* == Subline volgt de advertentie (2026-09-13): ?feel=<hoek> in de URL kiest
   de regel uit custom.sublines; de keuze blijft de sessie lang staan. */
(function () {
  var el = document.querySelector('.mrv-subline[data-mrv-sublines]');
  if (!el) return;
  var feel = null;
  try {
    feel = new URLSearchParams(location.search).get('feel');
    if (feel) sessionStorage.setItem('mrv-feel', feel);
    else feel = sessionStorage.getItem('mrv-feel');
  } catch (e) {}
  if (!feel) return;
  var lijst;
  try { lijst = JSON.parse(el.getAttribute('data-mrv-sublines') || '{}'); } catch (e) { return; }
  if (lijst && lijst[feel]) el.textContent = lijst[feel];
})();


/* == Impulse-koppeling (Nora Janne 3.0): Impulse wisselt de variant zonder 'change' op het id-veld.
   Bij elke variantwissel sturen we zelf een change-event, zodat de bundelkiezer meeloopt. */
(function () {
  function stuur() {
    document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (veld) {
      veld.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  document.addEventListener('variant:change', function () { setTimeout(stuur, 0); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.variant-wrapper, .variant-input-wrap, [data-variant-input]')) setTimeout(stuur, 50);
  });
})();
